import z from "zod";
import { defineObject } from "sanity-typed-queries";
import keyFiguresSectionFigure from "./keyFiguresSectionFigure.js";
import arrayEntry from "../fragments/arrayEntry.js";
var schema = defineObject("keyFiguresSection", {
    title: {
        title: "Title",
        type: "string"
    },
    subtitle: {
        title: "Subtitle",
        type: "string"
    },
    figures: {
        title: "Figures",
        type: "array",
        of: [
            {
                type: "keyFiguresSectionFigure"
            }
        ],
        validation: function(Rule) {
            return Rule.min(1);
        }
    }
}, [
    keyFiguresSectionFigure.schema.keyFiguresSectionFigure
]);
var validator = z.object({
    title: z.string(),
    subtitle: z.string(),
    figures: z.array(keyFiguresSectionFigure.validator.merge(arrayEntry.validator))
}).partial();
schema.keyFiguresSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=keyFiguresSection.js.map